export class DailyTripExpense{
    id: number;
    dailyTripId: number;
    expenseType: string;
    remarks: string;
    amount: number;
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
}


// WEBPACK FOOTER //
// ./src/app/models/trips/dailyTripExpense.ts